import { FC } from 'react';

import { Placeholder } from '@hh.ru/magritte-ui';
import { MagnifierOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { useSelector } from 'store/utils';

const TrlKeys = {
    description: {
        searchAndFilters: 'CampaignsDashboard.CampaignsTable.CampaignsNotFoundByFilters.description.searchAndFilters',
        searchOnly: 'CampaignsDashboard.CampaignsTable.CampaignsNotFoundByFilters.description.searchOnly',
        filtersOnly: 'CampaignsDashboard.CampaignsTable.CampaignsNotFoundByFilters.description.filtersOnly',
    },
    title: 'CampaignsDashboard.CampaignsTable.CampaignsNotFoundByFilters.title',
};

export const CampaignsNotFoundByFilters: FC = () => {
    const campaignsSearchValue = useSelector((state) => state.campaignsFilters.campaignsSearchValue);
    const appliedCampaignsFiltersTotalCount = useSelector(
        (state) => state.campaignsFilters.appliedCampaignsFiltersTotalCount
    );
    const trls = useTrls();

    const isSearchApplied = Boolean(campaignsSearchValue);
    const isFiltersApplied = appliedCampaignsFiltersTotalCount > 0;

    const description = () => {
        if (isSearchApplied && isFiltersApplied) {
            return trls(TrlKeys.description.searchAndFilters);
        } else if (isSearchApplied) {
            return trls(TrlKeys.description.searchOnly);
        }
        return trls(TrlKeys.description.filtersOnly);
    };

    return (
        <Placeholder
            description={description()}
            gapBottom={24}
            gapTop={24}
            paddingBottom={48}
            paddingTop={48}
            title={trls(TrlKeys.title)}
        >
            <MagnifierOutlinedSize24
                initialColor="secondary"
                backgroundStyle="secondary"
                borderRadius="halfHeight"
                padding={16}
            />
        </Placeholder>
    );
};
